import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import Layout from '../../templates/Layout';
import H1 from '../../atoms/title/H1';
import Panel from '../../atoms/Panel';
import Flex from '../../atoms/Flex';
import H3 from '../../atoms/title/H3';
import PasswordForm, { initialData, } from '../../molecules/form/account/PasswordForm';
import Button from '../../atoms/Button';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useForm } from '@inertiajs/react';
import Notice from '../../molecules/Notice';
import { useTheme } from 'styled-components';
const Update = ({ notice }) => {
    const { t } = useTranslation();
    const [noticeState, setNoticeState] = useState(notice);
    useEffect(() => {
        setNoticeState(notice);
    }, [notice]);
    const { data, setData, post, processing, errors, reset, } = useForm(initialData);
    const handleSubmit = (e) => {
        e.preventDefault();
        try {
            post(window.location.href, {
                onSuccess: () => {
                    reset();
                },
            });
        }
        catch (e) {
            setNoticeState({
                type: 'error',
                title: t('password_reset.password_not_changed_title'),
                text: t('password_reset.password_not_changed_text'),
            });
        }
    };
    const theme = useTheme();
    // @ts-ignore
    return (_jsxs(Layout, { children: [_jsx(Helmet, { children: _jsx("title", { children: t('my_account.title') }) }), _jsx(H1, { "data-testid": "title", children: t('my_account.title') }), _jsxs(Panel, { children: [noticeState && _jsx(Notice, { ...noticeState }), _jsxs("form", { style: {
                            width: '100%',
                        }, method: 'post', onSubmit: handleSubmit, children: [_jsxs(Flex, { column: true, children: [_jsx(H3, { children: t('my_account.change_password_title') }), _jsx(PasswordForm, { data: data, errors: errors, setData: setData, processing: processing })] }), _jsx(Flex, { justifyContent: "flex-end", margin: "45px 0 0 0", children: _jsx(Button, { secondary: true, isLoading: processing, 
                                    //@ts-ignore
                                    loaderColor: theme.primary.dark, children: t('buttons.save') }) })] })] })] }));
};
export default Update;
